import { render, staticRenderFns } from "./SBJDataCYD.vue?vue&type=template&id=74cec70c&scoped=true&"
import script from "./SBJDataCYD.vue?vue&type=script&lang=js&"
export * from "./SBJDataCYD.vue?vue&type=script&lang=js&"
import style0 from "./SBJDataCYD.vue?vue&type=style&index=0&id=74cec70c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cec70c",
  null
  
)

export default component.exports